import {
  ChartLineIcon,
  NavigatorItem,
  NavigatorLinkMenu,
  UserIcon,
} from '@forgeglobal/design-framework';
import SearchBar from '@tcs/client-portal-common/components/organisms/ApplicationLayout/SearchBar';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import NotificationZone from '@tcs/client-portal-common/components/molecules/NotificationZone';
import AppLayout from '@tcs/client-portal-common/components/organisms/ApplicationLayout';
import SearchResults from '@tcs/client-portal-common/components/templates/SearchResults';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import useReportNotifications from '@tcs/client-portal-common/hooks/useReportNotifications';
import Account from '@tcs/client-portal-representative/pages/Account';
import Accounts from '@tcs/client-portal-representative/pages/Accounts';
import Profile from '@tcs/client-portal-representative/pages/Profile';

const NAVIGATION_ITEMS: NavigatorItem[] = [
  {
    id: 'Accounts',
    icon: <ChartLineIcon />,
    to: '/accounts',
    exact: false,
  },
  {
    id: 'Profile',
    icon: <UserIcon />,
    to: '/profile',
    exact: false,
  },
];

const NAVIGATION_LINK_MENU: NavigatorLinkMenu = {
  title: 'I WANT TO...',
  navigatorLinkItems: [
    {
      id: 'Open a New Account',
      to: 'https://forgetrust.com/forms/open-a-new-account',
    },
    {
      id: 'Fund My Account',
      to: 'https://forgetrust.com/forms/fund-your-account',
    },
    {
      id: 'Make an Investment',
      to: 'https://forgetrust.com/forms/make-an-investment',
    },
    {
      id: 'Manage My Account',
      to: 'https://forgetrust.com/forms/manage-your-account',
    },
    {
      id: 'Disbursements and Distributions',
      to: 'https://forgetrust.com/forms/disbursements-and-distributions',
    },
  ],
};

const Layout = ({ clientPortalIdentity }) => {
  useReportNotifications();

  return (
    <AppLayout
      navigatorLinkMenu={NAVIGATION_LINK_MENU}
      navigatorItems={NAVIGATION_ITEMS}
      searchBar={
        <SearchBar savedItemsKey={clientPortalIdentity} type="representative" />
      }>
      {clientPortalIdentity && <NotificationZone />}
      <Outlet />
    </AppLayout>
  );
};

const Representative = () => {
  const {
    claims: { clientPortalIdentity },
  } = useSession();

  return (
    <Routes>
      <Route
        path="/"
        element={<Layout clientPortalIdentity={clientPortalIdentity} />}>
        <Route
          path="/"
          element={
            <Navigate state={{ from: '/' }} to="/accounts/all" replace />
          }
        />
        <Route path="/accounts/all/*" element={<Accounts />} />
        <Route path="/accounts/:accountNumber/*" element={<Account />} />
        <Route path="/results" element={<SearchResults />} />
        <Route path="/profile/*" element={<Profile />} />
        <Route
          path="*"
          element={<Navigate state={{ from: '*' }} to="/" replace />}
        />
      </Route>
    </Routes>
  );
};

export default Representative;
